module.exports = __webpack_public_path__ + "img/johanna-weiermann.0a871847.jpg";